<template>
  <div class="plv-iar-product-hot-click"
       :class="{'plv-iar-product-hot-click__labelMode': labelMode}">
    <div class="plv-iar-product-hot-click-icon">
      <img :src="hotClickIconImg"/>
    </div>
    <div class="plv-iar-product-hot-click-text">
      {{ hotEffectTip }}
      <span v-if="hotTimes >= 9999" class="plv-iar-product-hot-click-count-to plv-font-din-pro-regular">
        <span class="plv-iar-product-hot-click-count-prefix">x</span>9999+
      </span>
      <span
        v-else
        class="plv-iar-product-hot-click-count-to plv-font-din-pro-regular"
        :class="{'plv-iar-product-hot-click-count-to-animate': animate && hotTimes !== 0}" >
        <span class="plv-iar-product-hot-click-count-prefix">x</span>
        <CountTo
          ref="countTo"
          :start-val="lastHotTimes"
          :autoplay="false"
          :end-val="hotTimes"
          :duration="2000"/>
      </span>

    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to';
export default {
  components: {
    CountTo
  },
  props: {
    good: {
      type: Object,
      default: () => ({})
    },
    hotTimes: {
      type: Number,
      default: 0
    },
    lastHotTimes: {
      type: Number,
      default: 0
    },
    hotEffectTipOption: {
      type: Object,
      default: () => ({})
    },
    labelMode: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    hotClickIconImg() {
      return this.good.productType === 'normal' ?
        require('../imgs/icon-product-normal.png') :
        this.good.productType === 'finance' ?
          require('../imgs/icon-product-finance.png') :
          require('../imgs/icon-product-job.png');
    },
    hotEffectTip() {
      const hotEffectConstant = {
        normal: 'normalProductTips',
        position: 'jobProductTips',
        finance: 'financeProductTips'
      };

      return this.hotEffectTipOption[hotEffectConstant[this.good.productType]] || '热卖中';
    }
  },
  watch: {
    goods(val, oldVal) {
      if (oldVal && val.productId !== oldVal.productId) {
        this.$refs.countTo && this.$refs.countTo.reset();
      }
    },
    hotTimes: {
      immediate: true,
      handler(val) {
        if (val > 9999) {
          return;
        }
        this.animate = true;
        this.$refs.countTo && this.$refs.countTo.start();

        setTimeout(() => {
          this.animate = false;
        }, 1200);
      }
    },
  },
  data() {
    return {
      animate: false,
    };
  }
};
</script>

<style lang="scss">
@import '../../../assets/styles/basic.scss';

.plv-iar-product-hot-click {
  height: 24px;
  padding-left: 4px;
  border-radius: 12px;
  background: linear-gradient(271deg, rgba(255, 175, 15, 0) 1%, rgba(255, 175, 15, 0.8) 28%, #FFAF0F 99%);
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  &.plv-iar-product-hot-click__labelMode {
    width: auto;
    border-radius: 8px;
    height: 18px;
    position: initial;
    padding-right: 18px;
    .plv-iar-product-hot-click-icon {
      width: 12px;
      height: 12px;
      display: flex;
      align-items: center;
      margin-right: 2px;
      img {
        height: 100%;
      }
    }
  }

  .plv-iar-product-hot-click-text {
    color: #fff;
    font-size: 12px;
    display: flex;
  }

  .plv-iar-product-hot-click-count {
    display: flex;
    align-items: flex-end;
  }
  .plv-iar-product-hot-click-count-to-animate {
    animation: countAnimation 0.6s infinite;
  }
  .plv-iar-product-hot-click-count-to {
    margin-left: 4px;
  }

  .plv-iar-product-hot-click-icon {
    width: 16px;
    height: 16px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .plv-iar-product-hot-click-count-prefix {
    font-size: 10px;
    font-family: initial;
  }
}

@keyframes countAnimation {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}
</style>
